export const UPLOAD_REQUEST = 'UPLOAD/UPLOAD_REQUEST';
export const UPLOAD_SUCCESS = 'UPLOAD/UPLOAD_SUCCESS';
export const UPLOAD_FAIL = 'UPLOAD/UPLOAD_FAIL';